@switch (typeTemaplate) {
  @case ('items') {
    <ng-container *ngTemplateOutlet="templateItems"></ng-container>
  }
  @case ('prices') {
    <ng-container *ngTemplateOutlet="templatePrices"></ng-container>
  }
}

<ng-template #dialogError>
  <h2 mat-dialog-title>{{ '' | libTranslateLang: 'Error' : 'Erreur' }}</h2>
  <mat-dialog-content>
    <p>
      {{
        ''
          | libTranslateLang
            : 'Please check the number of tickets selected. Tickets must be selected for each event.'
            : 'Veuillez vérifier le nombre de billets sélectionnés. Vous devez sélectionner des billets pour chaque événement.'
      }}
    </p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close cdkFocusInitial>Ok</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #templateItems>
  <div style="margin: 2px; color: black">
    <div
      class="btn-floating-order mat-elevation-z2"
      style="display: flex; justify-content: center; background: white"
      [ngStyle]="!splitPrices && !bestsSelect ? { flexDirection: 'column' } : {}"
      id="{{ nameUnique }}">
      <div style="width: 100%">
        <div
          style="
            padding: 10px;
            font-weight: bold;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-content: center;
            justify-content: end;
          "
          class="temp-taxes-stats">
          <div class="titleTax">
            @if (!includTax) {
              @if (translate.currentLang === 'fr') {
                <span>*Tous les prix sont affichés avant taxes.</span>
              }
              @if (translate.currentLang !== 'fr') {
                <span>* All prices exclude tax.</span>
              }
            } @else {
              @if (translate.currentLang === 'fr') {
                <span>* Tous les prix incluent les taxes.</span>
              }
              @if (translate.currentLang !== 'fr') {
                <span>* All prices include tax.</span>
              }
            }

            <!--                <span>{{ 'cart.addToCart' | translate }} <span *ngIf="total>0">{{total / 100 | currency :'':'symbol-narrow':'':translate.currentLang}}</span></span>-->
          </div>
          <div style="align-items: center; justify-content: right" class="tw-flex tw-flex-flow-row-wrap">
            @if (qtyReserved > 0) {
              <div class="tw-flex tw-column" style="justify-content: center; align-items: center; margin-right: 5px">
                @if (qtyReserved === 1) {
                  <div class="tw-primary-color" style="text-align: right; width: 100%">
                    {{ qtyReserved }}
                    @if (onlyGiftCertificates) {
                      {{ '' | libTranslateLang: 'Gift Certificate ' : 'Certificat de cadeaux' }}
                    } @else {
                      {{ 'title.tickets' | translate }}
                    }
                  </div>
                }
                @if (qtyReserved > 1) {
                  <div class="tw-primary-color" style="text-align: right; width: 100%">
                    {{ qtyReserved }}
                    @if (onlyGiftCertificates) {
                      {{ '' | libTranslateLang: 'Gift Certificates ' : 'Certificats de cadeaux' }}
                    } @else {
                      {{ 'title.tickets' | translate }}
                    }
                  </div>
                }
                @if (total && translate.currentLang === 'fr') {
                  <div style="font-weight: bold; font-size: larger">
                    Total :
                    {{ total / 100 | currency: '' : 'symbol-narrow' : '' : translate.currentLang }}
                  </div>
                }
                @if (total && translate.currentLang !== 'fr') {
                  <div style="font-weight: bold; font-size: larger">
                    Total:
                    {{ total / 100 | currency: '' : 'symbol-narrow' : '' : translate.currentLang }}
                  </div>
                }
              </div>
            }
            <div class="tw-flex">
              @if (pageSaleService.page?.display === 'ITEMS') {
                @if (activeBtn) {
                  <button
                    style="height: auto; min-height: 40px"
                    mat-raised-button
                    color="primary"
                    (click)="createHoldPage()">
                    <mat-icon class="icon-add">add_shopping_cart</mat-icon>
                    <span>{{ 'cart.addToCart' | translate }}</span>

                    @if (!load) {
                      <div class="cssload-speeding-wheel"></div>
                    }
                  </button>
                } @else {
                  <button style="height: auto; min-height: 40px" mat-raised-button color="primary" (click)="goToCart()">
                    <mat-icon class="icon-add">shopping_cart_checkout</mat-icon>

                    <span>{{ 'title.cart' | translate }}</span>
                  </button>
                }
              } @else {
                <button
                  style="height: auto; min-height: 40px"
                  mat-raised-button
                  color="primary"
                  (click)="createHoldPage()"
                  [disabled]="!activeBtn">
                  <mat-icon class="icon-add">add_shopping_cart</mat-icon>
                  <span>{{ 'cart.addToCart' | translate }}</span>

                  @if (!load) {
                    <div class="cssload-speeding-wheel"></div>
                  }
                </button>
              }
            </div>
          </div>
        </div>
      </div>

      @if (!splitPrices && !bestsSelect && isDialog) {
        <div>
          @if (!load) {
            <mat-progress-bar></mat-progress-bar>
          }
          <button mat-raised-button color="primary" (click)="closeDialog()" style="width: 100%">
            <span>{{ 'title.next' | translate }}</span>
          </button>
        </div>
      }
    </div>
  </div>
</ng-template>
<ng-template #templatePrices>
  <div class="m-0.5 text-black border border-solid border-gray-200 rounded">
    <div class="btn-floating-order bg-white" id="{{ nameUnique }}">
      <!-- En-tête : N billets + Taxes incluses + Total -->
      <div
        class="px-4 py-3 flex justify-between items-center cursor-pointer lg:cursor-default lg:pointer-events-none"
        (click)="togglePriceList()">
        <span class="font-bold text-base">
          @if (totalQtyReserveAndQtyCart === 0) {
            {{ '' | libTranslateLang: 'No ticket selected' : 'Aucun billet sélectionné' }}
          } @else if (totalQtyReserveAndQtyCart === 1) {
            {{ totalQtyReserveAndQtyCart }} {{ '' | libTranslateLang: 'ticket' : 'billet' }}
          } @else {
            {{ totalQtyReserveAndQtyCart }} {{ '' | libTranslateLang: 'tickets' : 'billets' }}
          }
          @if (cartDetailTokenFlat.length + cartDonationFlat.length > 0) {
            @if (cartDetailTokenFlat.length + cartDonationFlat.length === 1) {
              <ng-container
                *ngTemplateOutlet="
                  bage;
                  context: {
                    text:
                      cartDetailTokenFlat.length +
                      cartDonationFlat.length +
                      ' ' +
                      ('' | libTranslateLang: 'Article' : 'Article')
                  }
                "></ng-container>
            } @else {
              <ng-container
                *ngTemplateOutlet="
                  bage;
                  context: {
                    text:
                      cartDetailTokenFlat.length +
                      cartDonationFlat.length +
                      ' ' +
                      ('' | libTranslateLang: 'Articles' : 'Articles')
                  }
                "></ng-container>
            }
          }
        </span>
        <div class="flex items-center gap-1.5">
          @if (totalQtyReserveAndQtyCart > 0) {
            <span class="text-gray-400 text-sm">
              @if (includTax) {
                {{ '' | libTranslateLang: 'Tax included' : 'Taxes incluses' }}
              } @else {
                {{ '' | libTranslateLang: 'Before tax' : 'Avant taxes' }}
              }
            </span>
          }
          @if (totalAmountReservedAndCart > 0) {
            <span class="font-bold text-base">
              {{ totalAmountReservedAndCart / 100 | currency: '' : 'symbol-narrow' : '' : translate.currentLang }}
            </span>
          }
          @if (totalQtyReserveAndQtyCart > 0) {
            <span class="lg:!hidden flex items-center justify-center w-6 h-6 rounded-full border border-gray-400">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; line-height: 18px">
                {{ isPriceListExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
              </mat-icon>
            </span>
          }
        </div>
      </div>
      <mat-divider style="margin: 0 15px"></mat-divider>

      <!-- Template commun pour une ligne d'item (prix / CartDetailToken / Parking) -->
      <ng-template
        #rowItemTpl
        let-label="label"
        let-sublabel="sublabel"
        let-color="color"
        let-showColor="showColor"
        let-prefix="prefix"
        let-promoColor="promoColor"
        let-originalLabel="originalLabel"
        let-badge="badge"
        let-deleteCallback="deleteCallback"
        let-getViewImageUrl="getViewImageUrl"
        let-priceLevelId="priceLevelId"
        >
        <li class="
    
        flex items-center py-2.5 border-b border-gray-100 last:border-0">
          <!-- Cercle coloré ou badge lettre -->
          @if (showColor) {
            @if (color) {
              <span class="seat-color-pricelevelid-{{ priceLevelId }} w-3 h-3 rounded-full flex-shrink-0 mr-3" [style.background-color]="color"></span>
            } @else {
              <span
                class="w-5 h-5 rounded flex-shrink-0 mr-3 flex items-center justify-center text-[10px] font-bold
                  bg-gray-200 text-gray-600">
                {{ prefix }}
              </span>
            }
          }

          <!-- Label + sublabel -->
          <span class="flex-1 text-sm leading-snug">
            {{ label }}
            <br />
            @if (originalLabel) {
              <span class="text-xs lg:text-sm font-normal text-gray-500 line-through">{{ originalLabel }}</span>
            }
            <strong [style.color]="promoColor || ''">{{ sublabel }}</strong>
            @if (badge) {
              <ng-container
                *ngTemplateOutlet="
                  bage;
                  context: { text: '' | libTranslateLang: 'Already in cart' : 'Déjà dans le panier' }
                "></ng-container>
            }
          </span>
          <!-- Bouton supprimer -->
          @if (getViewImageUrl) {
            <button
              mat-icon-button
              style="
                width: 36px;
                height: 36px;
                border: 1px solid #ccc;
                border-radius: 4px;
                flex-shrink: 0;
                display: inline-flex;
                align-items: center;
                justify-content: center;
              "
              (click)="showSeatMap(getViewImageUrl)">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; line-height: 18px">visibility</mat-icon>
            </button>
          }

          <button
            mat-icon-button
            style="
              width: 36px;
              height: 36px;
              border: 1px solid #ccc;
              border-radius: 4px;
              flex-shrink: 0;
              display: inline-flex;
              align-items: center;
              justify-content: center;
            "
            (click)="deleteCallback()">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; line-height: 18px">delete</mat-icon>
          </button>
        </li>
      </ng-template>

      <!-- Zone collapsible : masquée sur mobile/tablette, toujours visible sur desktop -->
      <div [class.hidden]="!isPriceListExpanded" class="lg:!block">
        <!-- Liste des prix en cours de sélection — une ligne par unité -->
        @if (priceManagerService.getPricesSelected().length > 0) {
          <ul class="px-4 py-1 m-0 list-none">
            @for (price of priceManagerService.getPricesSelected(); track price.id) {
              @for (i of getRange(price.qty); track i) {
                <ng-container
                  *ngTemplateOutlet="
                    rowItemTpl;
                    context: {
                      label: price.name,
                      sublabel:
                        (price.price + (price.serviceCharges || 0)) / 100
                        | currency: '' : 'symbol-narrow' : '' : translate.currentLang,
                      color: price.priceLevelColor || '#ccc',
                      showColor: !!price.rs,
                      promoColor: price.promoId ? 'var(--promo-code-color)' : '',
                      originalLabel:
                        price.promoId && price.originalPrice > 0
                          ? (price.originalPrice / 100 | currency: '' : 'symbol-narrow' : '' : translate.currentLang)
                          : null,
                      getViewImageUrl: getViewImageUrl(price, i),
                      deleteCallback: removeOneUnit.bind(this, price, i),
                      priceLevelId: price.priceLevelId
                    }
                  "></ng-container>
              }
            }
          </ul>
        }

        <!-- Liste CartDetailToken — billets déjà en panier -->
        @if (cartDetailTokenFlat.length > 0) {
          <ul class="px-4 py-1 m-0 list-none">
            @for (item of cartDetailTokenFlat; track item.token.idCartLine) {
              <!-- <pre >{{!!item.price.rs }}{{item.price.priceLevelColor }}</pre> -->
              <ng-container
                *ngTemplateOutlet="
                  rowItemTpl;
                  context: {
                    label: item.price.name,
                    sublabel:
                      (item.price.price + (item.price.serviceCharges || 0)) / 100
                      | currency: '' : 'symbol-narrow' : '' : translate.currentLang,
                    color: item.price.priceLevelColor || '#ccc',
                    showColor: !!item.price.rs,
                    badge: true,
                    getViewImageUrl: getViewImageUrlByCartDetail(item.token),
                    deleteCallback: deleteCartDetailToken.bind(this, item.token),
                    priceLevelId: item.price.priceLevelId
                  }
                "></ng-container>
            }
          </ul>
        }

        <!-- Liste Donations — dons déjà en panier -->
        @if (cartDonationFlat.length > 0) {
          <ul class="px-4 py-1 m-0 list-none">
            @for (item of cartDonationFlat; track item.price.id) {
              <ng-container
                *ngTemplateOutlet="
                  rowItemTpl;
                  context: {
                    label: item.price.name,
                    sublabel:
                      (item.price.price + (item.price.serviceCharges || 0)) / 100
                      | currency: '' : 'symbol-narrow' : '' : translate.currentLang,
                    color: item.price.priceLevelColor || '#ccc',
                    showColor: false,
                    badge: true,
                    deleteCallback: deleteDonationPrice.bind(this, item.price),
                    priceLevelId: item.price.priceLevelId
                  }
                "></ng-container>
            }
          </ul>
        }

        <!-- Liste Parking — stationnements déjà en panier -->
        @if (cartParkingFlat.length > 0) {
          <ul class="px-4 py-1 m-0 list-none">
            @for (p of cartParkingFlat; track p.id) {
              <ng-container
                *ngTemplateOutlet="
                  rowItemTpl;
                  context: {
                    label: p.name,
                    sublabel:
                      (p.amount / 100 | currency: '' : 'symbol-narrow' : '' : translate.currentLang) + ' / jour',
                    color: null,
                    prefix: 'P',
                    deleteCallback: deleteCartDetailParkingToken.bind(this, p),
                   
                  }
                "></ng-container>
            }
          </ul>
        }

        <!-- Code promo appliqué -->
        @if (appliedPromoCode) {
          <ul class="px-4 py-1 m-0 list-none">
            <li class="flex items-center py-2.5">
              <span class="flex-1 text-sm leading-snug">
                {{ '' | libTranslateLang: 'Promo code:' : 'Code promo :' }}
                <strong style="color: var(--promo-code-color)">{{ appliedPromoCode }}</strong>
              </span>
              <button
                mat-icon-button
                style="
                  width: 36px;
                  height: 36px;
                  border: 1px solid #ccc;
                  border-radius: 4px;
                  flex-shrink: 0;
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                "
                (click)="removePromo()">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; line-height: 18px">delete</mat-icon>
              </button>
            </li>
          </ul>
        }
      </div>
      <!-- /zone collapsible -->

      <!-- Footer : Code promo + Ajouter au panier -->
      <div class="px-4 pb-4 pt-2 flex gap-2">
        <button
          mat-stroked-button
          color="primary"
          style="height: auto; min-height: 48px; flex-basis: 35%; flex-shrink: 0"
          [disabled]="!showPromoButton"
          (click)="openPromoDialog()">
          @if (appliedPromoCode) {
            <span style="color: var(--promo-code-color)">
              {{ '' | libTranslateLang: 'Promo code applied' : 'Code promo appliqué' }}
            </span>
          } @else {
            {{ '' | libTranslateLang: 'Promo code' : 'Code promo' }}
          }
        </button>
        @if (qtyReserved === 0 && (cartDetailTokenFlat.length > 0 || cartDonationFlat.length > 0)) {
          <button
            style="height: auto; min-height: 48px; flex: 1"
            mat-raised-button
            color="primary"
            (click)="goToCart()">
            <mat-icon class="icon-add">shopping_cart_checkout</mat-icon>
            <span>{{ 'title.cart' | translate }}</span>
          </button>
        } @else {
          <button
            mat-raised-button
            color="primary"
            style="height: auto; min-height: 48px; flex: 1"
            (click)="createHoldPageWithParkingCheck()"
            [disabled]="!activeBtn">
            @if (!load) {
              <div class="cssload-speeding-wheel"></div>
            }
            <mat-icon class="icon-add">add_shopping_cart</mat-icon>
            <span>{{ 'cart.addToCart' | translate }}</span>
          </button>
        }
      </div>
    </div>
  </div>
</ng-template>
<!--<pre>{{pageSaleService.page | json}}</pre>-->
<!-- <ng-template #promoConfirmDialog></ng-template> -->
<ng-template #promoConfirmDialog>
  <div class="m-1">
    <tw-template-header-dialog
      titleEn="Promo Code Application"
      titleFr="Application du code promo"
      (closeClick)="dialog.closeAll()"></tw-template-header-dialog>

    <mat-dialog-content>
      <p class="text-sm leading-relaxed">
        {{
          ''
            | libTranslateLang
              : 'The promo code cannot be applied to tickets already selected. Please apply the code first, then select your tickets again.'
              : "Le code promo ne s'applique pas aux billets déjà sélectionnés. Veuillez appliquer le code en premier puis sélectionner vos billets à nouveau."
        }}
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="gap-2 !flex-nowrap">
      <button mat-raised-button (click)="continueWithPromo(false)" class="!text-xs">
        {{ '' | libTranslateLang: 'Continue without clearing' : 'Continuer sans vider la sélection' }}
      </button>
      <button mat-raised-button color="primary" (click)="continueWithPromo(true)" class="!text-xs">
        {{ '' | libTranslateLang: 'Clear and apply the code' : 'Vider et appliquer le code' }}
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>
<!-- 
<ng-template #promoDialog> -->
<ng-template #promoDialog>
  <div class="m-1">
    <tw-template-header-dialog
      titleEn="Enter promo code"
      titleFr="Entrer votre code promo"
      [disabled]="promoLoading"
      (closeClick)="closePromoDialog()"></tw-template-header-dialog>
    @if (promoApplied) {
      <mat-dialog-content class="overflow-visible pb-4">
        <div class="flex items-center gap-2">
          <mat-icon class="text-green-600 !text-[22px] !w-[22px] !h-[22px] !leading-[22px]">check_circle</mat-icon>
          <span class="text-sm">
            {{ '' | libTranslateLang: 'Promo code applied:' : 'Code promo appliqué :' }}
            <strong style="color: var(--promo-code-color)">{{ appliedPromoCode }}</strong>
          </span>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-raised-button color="primary" (click)="closePromoDialog()">
          {{ '' | libTranslateLang: 'Close' : 'Fermer' }}
        </button>
      </mat-dialog-actions>
    } @else {
      <mat-dialog-content class="pb-1 overflow-visible">
        <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
          <input matInput [(ngModel)]="promoInputValue" (keyup.enter)="applyPromo()" [disabled]="promoLoading" />
        </mat-form-field>
        @if (promoErrorMessage) {
          <div class="flex items-center gap-1.5 mt-2">
            <mat-icon class="text-red-600 !text-[18px] !w-[18px] !h-[18px] !leading-[18px]">error</mat-icon>
            <span class="text-red-600 text-[13px]">
              {{ '' | libTranslateLang: 'This promo code is not valid.' : "Ce code promo n'est pas valide." }}
            </span>
          </div>
        }
        @if (promoLoading) {
          <mat-progress-bar mode="indeterminate" class="mt-2"></mat-progress-bar>
        }
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-button (click)="closePromoDialog()" [disabled]="promoLoading">
          {{ '' | libTranslateLang: 'Cancel' : 'Annuler' }}
        </button>
        <button
          mat-raised-button
          color="primary"
          (click)="applyPromo()"
          [disabled]="!promoInputValue?.trim() || promoLoading">
          {{ '' | libTranslateLang: 'Apply' : 'Appliquer' }}
        </button>
      </mat-dialog-actions>
    }
  </div>
</ng-template>

<ng-template #parkingDialog>
  <div class="m-1">
    <tw-template-header-dialog
      titleEn="Parking"
      titleFr="Réserver un stationnement"
      (closeClick)="skipParking()"></tw-template-header-dialog>
    <mat-dialog-content>
      <p class="text-sm leading-relaxed">
        {{
          ''
            | libTranslateLang
              : 'Reserve a parking space. You will have a guaranteed spot on the day of your visit.'
              : 'Voulez-vous réserver une place de stationnement ? Vous aurez ainsi une place garantie le jour de votre visite.'
        }}
      </p>
      <tw-page-venue-parking
        [parkingData]="availableParkings"
        [isDialogMode]="true"
        [showTitle]="false"
        (selectedParkingsChange)="onParkingSelectionChange($event)"></tw-page-venue-parking>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="gap-2">
      <button mat-stroked-button (click)="skipParking()">
        {{ '' | libTranslateLang: 'No thanks' : 'Non merci' }}
      </button>
      <button mat-raised-button color="primary" (click)="confirmParking()" [disabled]="!hasParkingSelected()">
        {{ '' | libTranslateLang: 'Yes, reserve' : 'Oui, r\u00e9server' }}
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>
<ng-template #bage let-text="text">
  <span
    class="inline-flex items-center gap-0.5 text-[10px] font-medium rounded p-[3px] ml-[5px] align-middle text-green-800
      bg-green-50">
    <mat-icon style="font-size: 11px; width: 11px; height: 11px; line-height: 11px; color: #2e7d32">
      shopping_cart
    </mat-icon>
    {{ text }}
  </span>
</ng-template>
<ng-template #viewSeatTemplate>
  <tw-template-header-dialog
    titleEn="Seat Map"
    titleFr="Plan de salle"
    (closeClick)="dialog.closeAll()"></tw-template-header-dialog>
  <mat-dialog-content>
    <tw-template-view-seat [viewImageUrl]="selectedSeatMapViewImageUrl"></tw-template-view-seat>
  </mat-dialog-content>
</ng-template>
<!-- <pre>{{ priceManagerService.getPricesSelected() | json }}</pre>  -->
